import { TranslationType } from 'app/area/case-report/case-table-view/case-table-view-container';
import { CaseTableViewMetadata } from 'app/area/case-report/case-table-view/types-store';
import { AddRiskEvaluationInitialValues } from 'app/area/case/features/loss-potential-evaluation/types';
import { HeaderPanelProps } from 'app/components';
import { FavouriteDataColumn } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';
import { StoreData } from 'app/types-shared';
import * as React from 'react';
import { createContext } from 'react';

interface CaseTableViewContextData {
  rows:  StoreData[];
  columns: Partial<FavouriteDataColumn>[];
  locale: string;
  translation: TranslationType;
  onDeleteCase: (caseId: number) => void;
  onCopyRiskEvaluation: (caseId: number, riskMatrixInstance: number, instanceCopyCmd: number,
        initialValues: AddRiskEvaluationInitialValues, copyToResidual: boolean) => void;
  tableViewRef: React.RefObject<HTMLDivElement>;
  domainAttributes: CaseTableViewMetadata['domains'];
  tableContainerRef: React.RefObject<HTMLDivElement>;
  callsToActions?: HeaderPanelProps['callsToActions']; 
  onChangeCaseStatus?: HeaderPanelProps['onChangeCaseStatus'];
}

export const CaseTableViewContext = createContext(undefined as CaseTableViewContextData);
